/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessModule } from './AccessModule';
import {
    AccessModuleFromJSON,
    AccessModuleFromJSONTyped,
    AccessModuleToJSON,
} from './AccessModule';

/**
 * 
 * @export
 * @interface AccessCompletionResetRequest
 */
export interface AccessCompletionResetRequest {
    /**
     * 
     * @type {AccessModule}
     * @memberof AccessCompletionResetRequest
     */
    moduleName: AccessModule;
}

/**
 * Check if a given object implements the AccessCompletionResetRequest interface.
 */
export function instanceOfAccessCompletionResetRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "moduleName" in value;

    return isInstance;
}

export function AccessCompletionResetRequestFromJSON(json: any): AccessCompletionResetRequest {
    return AccessCompletionResetRequestFromJSONTyped(json, false);
}

export function AccessCompletionResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessCompletionResetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'moduleName': AccessModuleFromJSON(json['moduleName']),
    };
}

export function AccessCompletionResetRequestToJSON(value?: AccessCompletionResetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'moduleName': AccessModuleToJSON(value.moduleName),
    };
}

